import ahoy from 'ahoy.js'

// useAnalytics starts Ahoy only after confirming that the page is authenticated.
ahoy.configure({
  visitsUrl: '/internal/usage/visits',
  eventsUrl: '/internal/usage/events',
  startOnReady: false
})

export default ahoy
